/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonPoplistItem,
    JsonPoplistItemFromJSON,
    JsonPoplistItemFromJSONTyped,
    JsonPoplistItemToJSON,
} from './JsonPoplistItem';

/**
 * 
 * @export
 * @interface ApiResultOfMapOfstringAndListOfJsonPoplistItem
 */
export interface ApiResultOfMapOfstringAndListOfJsonPoplistItem {
    /**
     * 
     * @type {{ [key: string]: Array<JsonPoplistItem>; }}
     * @memberof ApiResultOfMapOfstringAndListOfJsonPoplistItem
     */
    data?: { [key: string]: Array<JsonPoplistItem>; };
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndListOfJsonPoplistItem
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfMapOfstringAndListOfJsonPoplistItem
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndListOfJsonPoplistItem
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfMapOfstringAndListOfJsonPoplistItem
     */
    result?: ApiResultOfMapOfstringAndListOfJsonPoplistItemResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfMapOfstringAndListOfJsonPoplistItemResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfMapOfstringAndListOfJsonPoplistItemFromJSON(json: any): ApiResultOfMapOfstringAndListOfJsonPoplistItem {
    return ApiResultOfMapOfstringAndListOfJsonPoplistItemFromJSONTyped(json, false);
}

export function ApiResultOfMapOfstringAndListOfJsonPoplistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfMapOfstringAndListOfJsonPoplistItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfMapOfstringAndListOfJsonPoplistItemToJSON(value?: ApiResultOfMapOfstringAndListOfJsonPoplistItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

